import {
  FETCH_PAGE_AUTOMATION_RULES,
  FetchPageAutomationRules,
  REMOVE_AUTOMATION_ACTION,
  RemoveAutomationAction,
  SAVE_AUTOMATION_RULE,
  SAVE_AUTOMATION_RULES_STATE,
  SaveAutomationRule,
  SaveAutomationRulesState,
  TOGGLE_AUTOMATION_RULE_PREVENT_SAVING,
  ToggleAutomationRulePreventSaving,
} from './automationRulesActionTypes'
import {
  AutomationRuleApiInterface,
  AutomationRuleRemoveActionInterface,
  AutomationRuleSaveInterface,
  AutomationRulesState,
  AutomationRuleTogglePreventSavingInterface,
} from './automationRulesReducer'

export function fetchPageAutomationRules(
  rules: AutomationRuleApiInterface[],
): FetchPageAutomationRules {
  return {
    type: FETCH_PAGE_AUTOMATION_RULES,
    payload: rules,
  }
}

export function saveAutomationRule(
  automationRule: AutomationRuleSaveInterface,
): SaveAutomationRule {
  return {
    type: SAVE_AUTOMATION_RULE,
    payload: automationRule,
  }
}

export function removeAutomationAction(
  automationRule: AutomationRuleRemoveActionInterface,
): RemoveAutomationAction {
  return {
    type: REMOVE_AUTOMATION_ACTION,
    payload: automationRule,
  }
}

export function toggleAutomationRulePreventSaving(
  automationRule: AutomationRuleTogglePreventSavingInterface,
): ToggleAutomationRulePreventSaving {
  return {
    type: TOGGLE_AUTOMATION_RULE_PREVENT_SAVING,
    payload: automationRule,
  }
}

export function saveAutomationRulesState(
  state: AutomationRulesState,
): SaveAutomationRulesState {
  return { type: SAVE_AUTOMATION_RULES_STATE, payload: state }
}
